import React from 'react';
import { di } from 'react-magnetic-di';
import SectionMessage from '@atlaskit/section-message';
import { useUiModificationsErrors } from '../use-ui-modifications-errors';
import { useUiModificationsNotifications } from '../use-ui-modifications-notifications';

export function UiModificationsSectionsMessages() {
    di(useUiModificationsErrors, useUiModificationsNotifications);
    const [uiModificationError] = useUiModificationsErrors();
    const [uiModificationsNotification] = useUiModificationsNotifications();

    const hasError = uiModificationError !== null;
    const hasNotification = uiModificationsNotification !== null;

    if (!hasError && !hasNotification) {
        return null;
    }

    return (
        <>
            {hasError && (
                <SectionMessage
                    appearance="error"
                    testId="issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
                >
                    {uiModificationError.message}
                </SectionMessage>
            )}
            {hasNotification && (
                <SectionMessage
                    appearance={uiModificationsNotification.type}
                    testId="issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
                >
                    {uiModificationsNotification.message}
                </SectionMessage>
            )}
        </>
    );
}
